import { useState } from 'react';
import { Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { editTemplate } from '../../controller';
import { requestHandler } from '../../helper';
import ErrorFilter from '../../helper/errorFilter';
import SingleError from '../../helper/SingleError';
import { UserValidateFields } from '../validate/userValidation';


function TemplateEdit({ id, tempData, getAllTemplateData, categoryData }) {
    const requireField = ["name", "pdf", "docx", "pptx"];

    const [urls, setUrls] = useState({ pdf: '', docx: '', pptx: '', xlsx: '' });
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
        handleEditUser(id);
    };

    const [templateName, setTemplateName] = useState('');

    const [isSample, setIsSample] = useState(false);

    const [errors, setErrors] = useState({});
    const [submitCount, setSubmitCount] = useState(0);

    const [isAll, setIsAll] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);

    const [categoryId, setCategoryId] = useState([]);

    const handleUrlInputChange = (event, type) => {
        const url = event.target.value;
        setUrls(prevFiles => ({ ...prevFiles, [type]: url }));
        let validationErrors = UserValidateFields({
            ...urls, [type]: url, name: templateName, categoryId: isAll ? [] : categoryId,
            isSample: isSample,
        });
        validationErrors = ErrorFilter(validationErrors, requireField);
        // Check if there's an error for the current type (pdf, docx, pptx)
        if (!validationErrors[type]) {
            const { [type]: removedError, ...remainingErrors } = errors;
            setErrors(remainingErrors);
        } else {
            setErrors(validationErrors);
        }
    };


    const handleEditUser = (id) => {
        const temp = tempData.find(temp => temp._id === id);
        if (temp) {
            setTemplateName(temp.name);
            setIsSample(temp.isSample);
            setUrls({
                pdf: temp.files.pdfPath,
                docx: temp.files.docxPath,
                pptx: temp.files.pptxPath,
                xlsx: temp.files.xlsxPath
            });

            // Check if categoryId is an array and get the category names
            if (Array.isArray(temp.categoryId) && temp.categoryId.length > 0) {
                const selectedCategoryNames = temp.categoryId.map(category => category.name).join(', '); // Join names with a comma
                const selectedCategoryIds = temp.categoryId.map(category => category._id); // Extract IDs
                setSelectedCategory(selectedCategoryNames); // Set the selected categories as a comma-separated string
                setCategoryId(selectedCategoryIds); // Set the category IDs as an array
            } else {
                setSelectedCategory(null); // No category selected
                setCategoryId([]); // Clear the category ID
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitCount((prevCount) => prevCount + 1);
        const data = {
            name: templateName,
            categoryId: isAll ? [] : categoryId,
            isSample: isSample,
            pdf: urls.pdf,
            docx: urls.docx,
            pptx: urls.pptx,
            xlsx: urls.xlsx,
        };


        // Validate the fields
        let validationErrors = UserValidateFields(data);
        validationErrors = ErrorFilter(validationErrors, requireField);

        setErrors(validationErrors);

        if (Object.keys(validationErrors).length === 0) {
            // Send the data directly in the body as JSON
            await requestHandler(
                () => editTemplate(data, id), // Pass the data object directly
                null,
                (res) => {
                    toast.success(res.message);
                    handleClose();
                    getAllTemplateData();
                    setTemplateName('');
                    setIsSample(false);
                    setUrls({ pdf: "", docx: "", pptx: "", xlsx: "" });
                    setSelectedCategory(null);
                    setIsAll(false);
                },
                () => { }
            );
        }
    };

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        const newValue = type === "checkbox" ? e.target.checked : value;

        if (submitCount > 0) {
            const data = {
                name: templateName,
                categoryId: isAll ? [] : categoryId,
                [name]: newValue,
            };
            let validationErrors = UserValidateFields(data);
            validationErrors = ErrorFilter(validationErrors, requireField);
            setErrors(validationErrors);
        }

        if (name === "templateName") {
            setTemplateName(newValue);
        } else if (name === "categoryId") {
            setCategoryId(newValue);
        }
    };

    const handleSampleToggle = (sampleStatus) => {
        setIsSample(sampleStatus);
        delete errors.isSample; // Clear the error if exists
        setErrors({ ...errors });
    };
    return (
        <>
            <OverlayTrigger
                key="tooltip"
                placement="top"
                overlay={<Tooltip id={`tooltip-top`}>Edit</Tooltip>}
            >
                <button className='border-0' onClick={handleShow}>
                    <img src="../images/png/edit2.png" alt="" />
                </button>
            </OverlayTrigger>


            <Modal className='modal-main' scrollable show={show} centered size='md' onHide={handleClose}>
                <Modal.Body>
                    <Modal.Title>
                        <div className="row justify-content-center">
                            <div className="col-11 col-8">
                                <h2>Edit Template</h2>
                            </div>
                        </div>
                    </Modal.Title>
                    <div className='modal-form'>
                        <Form onSubmit={handleSubmit}>
                            {/* File Uploads */}
                            {['pdf', 'docx', 'pptx', 'xlsx'].map((type) => (
                                <Form.Group className="mb-3" key={type}>
                                    <Form.Label>Enter {type.toUpperCase()} URL</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder={`Enter ${type.toUpperCase()} URL`}
                                        value={urls[type]}
                                        onChange={(e) => handleUrlInputChange(e, type)}
                                    />
                                    <SingleError error={errors?.[type]} />
                                </Form.Group>
                            ))}
                            {/* Template Name Input */}
                            <Form.Group className="mb-3">
                                <Form.Label>Template Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Template Name"
                                    value={templateName}
                                    onChange={handleChange}
                                    name="templateName"

                                />
                                <SingleError error={errors?.name} />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formGroupPassword">
                                <Form.Label>Is Sample</Form.Label>
                                <Dropdown className='status-btn'>
                                    <Dropdown.Toggle id="dropdown-basic">
                                        {isSample ? 'Yes' : 'No'}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => handleSampleToggle(false)}>No</Dropdown.Item>
                                        <Dropdown.Item onClick={() => handleSampleToggle(true)}>Yes</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Form.Group>
                            {/* Category Selection */}
                            <Form.Group className="mb-3">
                                <Form.Label>Category</Form.Label>
                                <Dropdown className='status-btn'>
                                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                                        {isAll ? 'All' : selectedCategory || 'Select Category'}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        {/* <Dropdown.Item onClick={() => {
                                            setIsAll(true);
                                            setCategoryId([]);
                                            setSelectedCategory(null);
                                        }}>
                                            All
                                        </Dropdown.Item> */}
                                        {categoryData.map((category, index) => (
                                            <Dropdown.Item
                                                key={index}
                                                onClick={() => {
                                                    setIsAll(false);
                                                    setCategoryId([category._id]);
                                                    setSelectedCategory(category.name);
                                                    setErrors(prevErrors => {
                                                        const newErrors = { ...prevErrors };
                                                        delete newErrors.categoryId;
                                                        return newErrors;
                                                    });
                                                }}
                                            >
                                                {category.name}
                                            </Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                </Dropdown>
                                {/* <SingleError error={errors?.categoryId} /> */}
                            </Form.Group>

                            <div className='d-md-flex align-items-center gap-3 mt-4'>
                                <button className='cancel-btn' onClick={handleClose} type='button'>Cancel</button>
                                <button className='save-btn' type='submit'>Save</button>
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default TemplateEdit